import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AuthService } from './auth/auth.service';
import { Injectable } from '@angular/core';
import { MarketplaceAppService } from './marketplace-app/marketplace-app.service';
import { AddonService } from './addon.service';

@Injectable()
export class FeatureFlipperService {
  constructor(
    private authService: AuthService,
    private marketplaceAppService: MarketplaceAppService,
    private addonService: AddonService,
  ) {}

  public canAccessPendingActivations(appId: string): Observable<boolean> {
    return this.marketplaceAppService.getDraft(appId).pipe(
      map(
        (app) => (app || { integration: { activationRequiresApproval: false } }).integration.activationRequiresApproval,
      ),
      switchMap((appActivationRequiresApproval) => {
        if (appActivationRequiresApproval) {
          return of(true);
        } else {
          return this.addonService.list(appId).pipe(
            map((adl) => {
              let addonNeedsPendingActivation = false;
              if (adl && adl.length) {
                addonNeedsPendingActivation = adl.some((ad) => ad.activationRequiresApproval);
              }
              return addonNeedsPendingActivation;
            }),
          );
        }
      }),
    );
  }

  public canSeeAllColumns(): Observable<boolean> {
    return this.authService.isSuperAdmin$;
  }
}
